import type { User } from "../models/user";
import type { UserRole } from "../models/user-role";

export const isInRole = (user: User, roles: UserRole[]) => {
  return Boolean(roles.find(role => user.role == role));
};